define(function (require) {
    "use strict";

    var LE = require("app");
    var LEConfig = require("assets/config/le-env-conf");

    var Page = require("ui.components/page/Page");

    var DataSourcesTabsLayout = require("manager-views/data-sources/DataSourcesTabsLayout");

    var ConversationSourcesGalleryController = require("manager-controllers/data-sources/conversation-sources/ConversationSourcesGalleryController");
    var IntegrationsListController = require("manager-controllers/data-sources/integrations/IntegrationsListController");
    var ApiKeysListController = require("manager-controllers/data-sources/api-keys/ApiKeysListController");

    var TABS = {
        SOURCES: "sources",
        INTEGRATIONS: "integrations",
        API_KEYS: "apiKeys"
    };

    var TABS_MAP = {};
    TABS_MAP[TABS.SOURCES] = {
        dictionaryKey: "conversationSources",
        path: "data/sources",
        ViewController: ConversationSourcesGalleryController,
        isEnabled: function() {
            return LE.sessionManager.hasConversationSourcesFeature() || (LE.sessionManager.hasAsyncMessagingFeature() && LEConfig.c4mMobileApp);
        }
    };

    TABS_MAP[TABS.INTEGRATIONS] = {
        dictionaryKey: "integrations",
        path: "data/integrations",
        ViewController: IntegrationsListController,
        isEnabled: function() {
            return true;
        }
    };

    TABS_MAP[TABS.API_KEYS] = {
        dictionaryKey: "apiKeys",
        path: "data/apiKeys",
        ViewController: ApiKeysListController,
        isEnabled: function() {
            return LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_API_KEYS_MANAGEMENT) && LE.sessionManager.hasApiKeyManagementFeature();
        }
    };


    var DataSourcesTabsController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        DataSourcesTabsController = Marionette.Controller.extend({
            pageView: null,
            tabsLayout: null,
            insideView: null,
            selectedTabId: null,

            initialize: function(options) {
                this._initialize(options);
            },

            getView: function() {
                return this._getView();
            },

            showSourcesTab: function() {
                this._showSourcesTab();
            },

            showIntegrationsTab: function() {
                this._showIntegrationsTab();
            },

            showApiTab: function() {
                this._showApiTab();
            },

            getFirstTabPath: function() {
                return _getFirstTabPath();
            },

            _initialize: function(options) {
                LEManager.logger.info("initializing", "ModuleTabsController:initialize");

                _.each(TABS,function(tabConfig){
                    var config = TABS_MAP[tabConfig];
                    config.viewController = new config.ViewController();
                },this);

                this.channel = LEManager.media.channel("dataSourcesTabs");
                this._bindEvents();
            },

            _bindEvents: function() {
                this.listenTo(this.channel, "dataSourcesTabs:page:close", this._onCloseClick);
                this.listenTo(this.channel, "dataSourcesTabs:tab:change", this._onHeaderTabsChange);
            },

            _getView: function() {
                this._initPageView();
                return this.pageView;
            },

            _initPageView: function () {
                if (!this.pageView) {
                    this.pageView = new Page({
                        moduleName: LEManager.moduleName,
                        context: LE.context,
                        permutation: Page.PERMUTATION.Dialog,
                        isPermanent: true,
                        header: {
                            title: LE.translator.translate("LEManager.dataSources.header.title"),
                            description: LE.translator.translate("LEManager.dataSources.header.description")
                        }
                    });
                    this._bindEventsPage();
                }
            },

            _bindEventsPage: function() {
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _onPageClose: function() {
                if (this.pageView) {
                    this.stopListening(this.pageView);
                }
                this.pageView = null;
            },

            _showSourcesTab: function() {
                this.selectedTabId = TABS.SOURCES;
                this._showView();
            },

            _showIntegrationsTab: function() {
                this.selectedTabId = TABS.INTEGRATIONS;
                this._showView();
            },

            _showApiTab: function() {
                this.selectedTabId = TABS.API_KEYS;
                this._showView();
            },

            _showView: function(viewOptions) {
                this.insideView = TABS_MAP[this.selectedTabId].viewController.getView();

                if (_.isEmpty(this.pageView.getInsideView())) {
                    this.tabsLayout = new DataSourcesTabsLayout({tabs:_getHeaderTabsArr(), selectedTab:this.selectedTabId});
                    this.listenToOnce(this.tabsLayout, "render", _.bind(function(){
                         this.tabsLayout.selectedTabRegion.show(this.insideView);
                    },this));
                    this.pageView.setInsideView(this.tabsLayout);
                }
                else {
                    this.tabsLayout.setSelectedTab(this.selectedTabId);
                    this.tabsLayout.selectedTabRegion.show(this.insideView);
                }
            },

            _onHeaderTabsChange: function(selectedTabId) {
                var path = TABS_MAP[selectedTabId].path;

                LEManager.router.navigateNonBackable(path);
            },

            _onCloseClick: function() {
                LEManager.router.navigateBack();
            }
        });

        function _getHeaderTabsArr() {
            var tabsArr = [];
            _.each(TABS, function(tab) {
                if(TABS_MAP[tab].isEnabled()) {
                    var tabItem = {
                        id: tab,
                        name: LE.translator.translate("LEManager.dataSources.tab." + TABS_MAP[tab].dictionaryKey + ".title")
                    };

                    tabsArr.push(tabItem);
                }
            });
            return tabsArr;
        }

        function _getFirstTabPath() {
            var path = TABS_MAP[TABS.INTEGRATIONS].path; //use a default for those who has no permissions at all
            var tabsArr = _getHeaderTabsArr();
            if (tabsArr[0]) {
                path = TABS_MAP[tabsArr[0].id].path;
            }
            return path;
        }
    }

    LE.module("LEManager", moduleDefinition);

    return  DataSourcesTabsController;
});
